import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      <div className="about-background">
        <div className="about-bg-gradient"></div>
        <div className="about-bg-grid"></div>
      </div>

      <div className="about-container">
        <header className="about-header">
          <Link to="/" className="about-logo">
            <span className="about-logo-icon">◆</span>
            <span className="about-logo-text">SOLOLA</span>
          </Link>
          <p className="about-tagline">La plateforme de visioconférence moderne, sécurisée et simple à utiliser.</p>
        </header>

        <main className="about-content">
          <section className="about-section">
            <h2>Qu'est-ce que SOLOLA ?</h2>
            <p>
              SOLOLA est une plateforme de visioconférence conçue pour permettre à chacun
              de se connecter facilement, quel que soit l'endroit où il se trouve.
              Elle combine fluidité, sécurité et performance pour offrir une expérience
              d'appel vidéo claire et fiable.
            </p>
          </section>

          <section className="about-section">
            <h2>Nos valeurs</h2>
            <div className="about-values">
              <div className="about-value-card">
                <h3>Simplicité</h3>
                <p>Une interface intuitive pour démarrer, rejoindre ou partager une réunion en quelques clics.</p>
              </div>
              <div className="about-value-card">
                <h3>Accessibilité</h3>
                <p>Utilisable depuis un navigateur, sans installation compliquée, pour tous les profils d'utilisateurs.</p>
              </div>
              <div className="about-value-card">
                <h3>Sécurité</h3>
                <p>Vos réunions peuvent être protégées grâce à des contrôles d'accès et des options de confidentialité.</p>
              </div>
              <div className="about-value-card">
                <h3>Qualité</h3>
                <p>Nous visons une expérience stable et fluide pour les appels vidéo et partages d'écran.</p>
              </div>
            </div>
          </section>

          <section className="about-section">
            <h2>Pourquoi SOLOLA ?</h2>
            <p>
              Nous croyons que la communication à distance doit être aussi naturelle
              qu'une conversation en face à face. SOLOLA rassemble les fonctionnalités
              essentielles pour travailler, étudier ou échanger en équipe sans perte
              de temps ni complications techniques.
            </p>
          </section>

          <section className="about-section about-cta">
            <h2>Prêt à essayer ?</h2>
            <p>Créez un compte gratuitement et commencez à organiser ou rejoindre des réunions dès maintenant.</p>
            <div className="about-actions">
              <Link to="/register" className="about-btn about-btn-primary">Créer un compte</Link>
              <Link to="/" className="about-btn about-btn-secondary">Retour à l'accueil</Link>
            </div>
          </section>
        </main>

        <footer className="about-footer">
          <p>© {new Date().getFullYear()} SOLOLA. Tous droits réservés.</p>
          <div className="about-footer-links">
            <Link to="/">Accueil</Link>
            <Link to="/login">Connexion</Link>
            <Link to="/register">Inscription</Link>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default About;
